import { render } from "./ModalRankings.vue?vue&type=template&id=e0533ad8&scoped=true"
import script from "./ModalRankings.vue?vue&type=script&lang=js"
export * from "./ModalRankings.vue?vue&type=script&lang=js"

import "./ModalRankings.vue?vue&type=style&index=0&id=e0533ad8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0533ad8"]])

export default __exports__